import React, { ChangeEvent, Component, createRef } from "react";
import { Alert, Button, Checkbox, CssBaseline, FormControl, FormControlLabel, FormGroup, Grid, Paper, Radio, RadioGroup, Snackbar, TextField, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import WSRO_LOGO_WHITE from "./../../assets/images/WSRO-logo.png";
import CREMEGLOBAL from "./../../assets/images/svg/cremeLogo.svg";
import Frame1 from "./../../assets/images/svg/frame-11.svg";
import Frame2 from "./../../assets/images/svg/frame-22.svg";
import Frame3 from "./../../assets/images/svg/frame-3.svg";

// TODO: refactor disclaimer links all over the app by context or exports
const disclaimerPdf = require("./../../assets/docs/Disclaimers.pdf");

// TODO: collect all types and interfaces in export files 
type Props = {};

type State = {
	signUp: {
		email: string;
		firstName: string;
		lastName: string;
		country: string;
		employer: string;
		sector: string;
		jobTitle: string;
	},
	error: string,
	formError: {
		email: boolean;
		firstName: boolean;
		lastName: boolean;
		country: boolean;
		employer: boolean;
	}
	cookieStatus: boolean;
	displayCookieErrorMessage: string;
	errorOpen: boolean,
	successMessageHidden: boolean,
	errorMessageHidden: boolean,
	isBarOpen: boolean,
	signUpProcessing: boolean,
	message: string,
	severity: "success" | "error" | "info" | "warning" | undefined,
};



export default class SignUp extends Component<Props, State> {
	// create a ref for register form
	registerFormRef = createRef<HTMLFormElement>();
	registerButtonRef = createRef<HTMLButtonElement>();

	constructor(props: Props) {
		super(props);
		this.state = {
			signUp: {
				email: "",
				firstName: "",
				lastName: "",
				country: "",
				sector: this.sectors[0],
				employer: "",
				jobTitle: "",
			},
			cookieStatus: false,
			displayCookieErrorMessage: 'none',
			error: "",
			formError: {
				email: false,
				firstName: false,
				lastName: false,
				country: false,
				employer: false,
			},
			errorOpen: false,
			successMessageHidden: true,
			errorMessageHidden: true,
			isBarOpen: false,
			signUpProcessing: false,
			message: "",
			severity: "success",
		};

	}


	sectors = [
		'Education',
		'Food & Drink Industry',
		'Food Service/Hospitality',
		'Health Services',
		'Government',
		'Media',
		'NGO/Charity',
		'Research',
		'Other'
	];

	// TODO: define a responsiveness 
	useStyles = makeStyles()((theme: any) => ({
		signUpForm: {
			width: '100%',
			marginTop: theme.spacing(1),
		},
		signUpButton: {
			margin: theme.spacing(1, 0, 1, 0),
		},
		signUpLink: {
			margin: theme.spacing(1, 0, 1, 0),
			textDecoration: 'none',
			color: '#000',
		},
		signUpLinkText: {
			color: '#000',
		},
		signUpLinkTextActive: {
			color: '#000',
			fontWeight: 'bold',
		},
		signUpLinkTextDisabled: {
			color: '#000',
			fontWeight: 'bold',
			cursor: 'not-allowed',
		},
	}));


	errorClose = () => this.setState({ errorOpen: false });
	handleChange = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
		const { name, value } = event.target;
		this.setState({
			signUp: {
				...this.state.signUp,
				[name]: value
			}
		});
	}


	handleChangeSector = (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
		const { name, value } = event.target;
		const sectorValue = this.sectors[parseInt(value)];
		// const newSectorValue = this.state.signUp.sector.includes(sectorValue) ? this.state.signUp.sector.replace(sectorValue, '') : this.state.signUp.sector + ', ' + sectorValue;
		this.setState({
			signUp: {
				...this.state.signUp,
				['sector']: sectorValue
			}
		});
	}

	handleBarClosed = () => {
		if (this.state.severity === "success") {
			this.setState({ isBarOpen: true });
		} else {
			this.setState({ isBarOpen: false });
		}
	}

	isValidEmail = (email: string) => {
		const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email).toLowerCase());
	}


	isValid = () => {
		const { email, firstName, lastName, country, employer } = this.state.signUp;
		return this.isValidEmail(email) && firstName.length > 0 && lastName.length > 0 && country.length > 0 && employer.length > 0 && this.state.cookieStatus;
	}

	submitSignUp = (event: any) => {
		if (this.isValid()) {
			event.preventDefault();
			this.setState({ signUpProcessing: true });
			// change register button color to grey
			if (this.registerButtonRef.current) {
				this.registerButtonRef.current.style.backgroundColor = '#ccc';
			}
			const { signUp } = this.state;
			let data: any = {
				email: signUp.email,
				first_name: signUp.firstName,
				last_name: signUp.lastName,
				country: signUp.country,
				employer: signUp.employer,
				sector: signUp.sector,
			};

			// add job title if it is not empty
			if (signUp.jobTitle.length > 0) {
				data['job_title'] = signUp.jobTitle;
			}

			const signupRequestConfig = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					'Accept': 'application/json',
					'Access-Control-Allow-Origin': '*',
					'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
					'Access-Control-Allow-Headers': 'Origin, Content-Type, X-Auth-Token',
					'Access-Control-Allow-Credentials': 'true',
				},
				body: JSON.stringify(data),
				url: 'https://wsro.cremedatafoundry.com/register',
				// url: "https://wsro-dev.cremedatafoundry.com/register"
			};


			fetch(signupRequestConfig.url, signupRequestConfig)
				.then(response => {
					if (response.ok && response.status === 201) {
						this.setState({
							signUp: {
								email: "",
								firstName: "",
								lastName: "",
								country: "",
								sector: this.sectors[0],
								employer: "",
								jobTitle: "",
							},
							formError: {
								email: false,
								firstName: false,
								lastName: false,
								country: false,
								employer: false,
							},
							displayCookieErrorMessage: 'none',
							isBarOpen: true,
							message: "Thank you for registering. Please check for an email from Data Foundry with a link to activate your account and set your password.",
							severity: "success",
							signUpProcessing: false,
						});

					} else if (response.ok === false && response.status === 400) {
						// something went wrong, please
						this.setState({
							isBarOpen: true,
							message: "Something went wrong, please try again.",
							severity: "error",
							signUpProcessing: false,
							displayCookieErrorMessage: 'none',

						});

					} else if (response.ok === false && response.status === 409) {
						// email already exists
						this.setState({
							isBarOpen: true,
							message: "Email already exists, please try again.",
							severity: "error",
							signUpProcessing: false,
							displayCookieErrorMessage: 'none',

						});
					}

					if (this.registerButtonRef.current) {
						this.registerButtonRef.current.style.backgroundColor = '#2462FF';
					}


				}).catch(err => {
					this.setState({
						isBarOpen: true,
						message: "Something went wrong, please try again.",
						severity: "error",
						signUpProcessing: false,
					});
					if (this.registerButtonRef.current) {
						this.registerButtonRef.current.style.backgroundColor = '#2462FF';
					}
				});
		} else {
			this.setState({
				formError: {
					email: !this.isValidEmail(this.state.signUp.email),
					firstName: this.state.signUp.firstName.length === 0,
					lastName: this.state.signUp.lastName.length === 0,
					country: this.state.signUp.country.length === 0,
					employer: this.state.signUp.employer.length === 0,
				},
				signUpProcessing: false,
				displayCookieErrorMessage: 'block',
			});

		}
	}

	handleChangeCheckboxCookie = (event: any) => {
		event?.preventDefault();
		const status = event.target.checked || false;
		this.setState({ cookieStatus: status });
		if(status){
			this.setState({ displayCookieErrorMessage: 'none' });
		}else{
			this.setState({ displayCookieErrorMessage: 'block' });
		}
	}

	scrollToRef = (ref: any) => {
		this.registerFormRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
	};

	render() {

		// TODO: issue cause a problem
		// const { classes } = this.useStyles();

		return (
			<Grid>
				<CssBaseline />
				<Paper
					elevation={0}
					style={{
						backgroundColor: "#fff"
					}}
				>
					<Grid item xs={12} style={{
						background: "#9AACD8",
						padding: "4rem"
					}}>
						<Grid item xs={12} style={{
							display: "flex",
							justifyContent: "space-between",
						}}>
							<Grid item xs={6} style={{ textAlign: "left", paddingLeft: "4rem" }}>
								<img src={WSRO_LOGO_WHITE} alt="logo" style={{ width: "80px" }} />
							</Grid>
							<Grid item xs={6} style={{ textAlign: "right", paddingRight: "2rem" }}>
								<img src={CREMEGLOBAL} alt="logo" style={{ width: "200px" }} />
							</Grid>
						</Grid>
						{/* row  */}
						<Grid item xs={12} style={{ display: "flex", justifyContent: "space-between" }}>
							<Grid item xs={6} style={{
								width: "49%",
								marginTop: "6rem",
								textAlign: "center"
							}}>
								<Typography variant="h1" style={{
									fontSize: "3rem",
									width: "80%",
									margin: "0 auto",
								}}>
									{"Welcome to WSRO Global Sugars Intake Dashboard"}
								</Typography>
								<Grid item xs={6}
									style={{
										marginTop: "3rem",
										paddingTop: "3rem",
										paddingLeft: "5rem",
										width: "80%",
										textAlign: "left",
										margin: "0 auto",
									}}
								>
									<Button variant="contained" color="primary"
										onClick={() => this.scrollToRef(this.registerFormRef)}
										style={{
											marginTop: "2rem",
											width: "45%",
											color: "#fff",
											cursor: "pointer",
											height: "3rem",
											margin: "0 auto",
											fontSize: "1.2rem",
											fontWeight: "bold",
											borderRadius: "0.0rem",
											backgroundColor: "#2462FF",
										}}>
										{"Register"}
									</Button>

									<p>
										{"Already have an account? Login"}
										<Button variant="text"
											color="primary"
											// onClick={() => window.location.href = "https://wsro-dev.cremedatafoundry.com/sign-sso"}
											onClick={() => window.location.href = "https://wsro.cremedatafoundry.com/sign-sso"}
											style={{
												color: "#2462FF",
												textTransform: "none",
												padding: "0",
											}}>
											{"here"}
										</Button>
									</p>
								</Grid>

							</Grid>
							<Grid item xs={6}>
								<img src={Frame1} alt="shape 1" style={{ width: "100%" }} />
							</Grid>
						</Grid>
					</Grid>
					{/* section 2  */}
					<Grid style={{
						background: "#CAD8E5",
						padding: "8rem 4rem",
						borderTop: "3px solid #000",
						borderBottom: "3px solid #000"
					}}>
						<Grid style={{ display: "flex", justifyContent: "space-between" }}>
							<Grid style={{ width: "48%" }}>
								<img src={Frame2} alt="frame 2" style={{
									width: "70%",
									margin: "0 auto",
									display: "block"
								}} />
							</Grid>
							<Grid style={{
								width: "48%",
								textAlign: "center"
							}}>
								<Typography variant="h1" style={{
									fontSize: "3rem",
									textAlign: "left",
									fontWeight: "bold",
									width: "60%",
									margin: "0",
								}}>
									{"About the dashboard and the data used"}
								</Typography>
								<p
									style={{
										fontSize: "1.3rem",
										lineHeight: "2.4rem",
										textAlign: "left",
										width: "60%",
										margin: "0 ",
										marginTop: "2rem",
									}}>
									{"The dashboard incorporates data from over 40 countries and allows users to obtain meaningful insights regarding the intakes of sugars in population groups across the globe. The dashboard incorporates data from a 2021 paper on sugar intakes led by Dr. Jeanette Walton, and expanded upon with an exhaustive literature review of sugar intakes which included studies, national food consumption surveys and national authority reports on food intakes and nutrition."}
								</p>

							</Grid>
						</Grid>
					</Grid>
					<Grid>
						<Grid
							id="register-form"
							// add ref to the component
							ref={this.registerFormRef as any}
							style={{
								textAlign: "center",
								margin: "0 auto",
								padding: "0",
								background: "#DBE6F3",
								transform: "rotate(-180deg)"
							}}>
							<Grid style={{
								transform: "rotate(-180deg)",
								margin: 0,
								padding: "4rem auto"

							}}>
								<Typography variant="h2" style={{
									textAlign: "left",
									fontWeight: "bold",
									width: "40%",
									margin: "0 auto 2rem auto",
									paddingTop: "3rem"
								}}>
									{"Register for free"}
								</Typography>
								<Typography variant="h6" style={{
									textAlign: "left",
									width: "40%",
									margin: "1rem auto",
									paddingTop: "1rem"
								}}>
									{"You can register for free, login and use the database as required. Leave comments or feedback on the message board on how we can improve the database and identify new data sources."}
								</Typography>
								<form
									onSubmit={() => this.submitSignUp}
									style={{
										display: "flex",
										flexDirection: "column",
										alignItems: "center",
										justifyContent: "center",
										width: "40%",
										paddingTop: "2rem",
										margin: "auto"
									}}
								>
									<FormControl required fullWidth margin="normal">
										<TextField
											label="First Name"
											type="text"
											error={this.state.formError.firstName}
											id="outlined-error"
											required={true}
											value={this.state.signUp.firstName}
											onChange={(e) => this.handleChange(e)}
											name="firstName"
											margin="normal"
											variant="outlined"
										/>
									</FormControl>

									<FormControl required fullWidth margin="normal">
										<TextField
											label="Last Name"
											type="text"
											error={this.state.formError.lastName}
											required={true}
											onChange={(e) => this.handleChange(e)}
											name="lastName"
											value={this.state.signUp.lastName}
											autoComplete="lastName"
											margin="normal"
											variant="outlined"
										/>
									</FormControl>
									<FormControl required fullWidth margin="normal">
										<TextField
											label="Email"
											type="email"
											error={this.state.formError.email}
											onChange={(e) => this.handleChange(e)}
											name="email"
											required={true}
											autoComplete="email"
											value={this.state.signUp.email}
											margin="normal"
											variant="outlined"
										/>
									</FormControl>
									<FormControl required fullWidth margin="normal">
										<TextField
											label="Job Title"
											type="text"
											onChange={(e) => this.handleChange(e)}
											name="jobTitle"
											value={this.state.signUp.jobTitle}
											autoComplete="job"
											margin="normal"
											variant="outlined"
										/>
									</FormControl>
									<FormControl required fullWidth margin="normal">
										<TextField
											label="Employer/Institutional Affiliation name"
											type="text"
											error={this.state.formError.employer}
											onChange={(e) => this.handleChange(e)}
											name="employer"
											required={true}
											autoComplete="employer"
											value={this.state.signUp.employer}
											margin="normal"
											variant="outlined"
										/>
									</FormControl>
									<FormControl required fullWidth margin="normal">
										<TextField
											label="Country"
											type="text"
											required={true}
											onChange={(e) => this.handleChange(e)}
											name="country"
											error={this.state.formError.country}
											value={this.state.signUp.country}
											autoComplete="country"
											margin="normal"
											variant="outlined"
										/>
									</FormControl>
									<RadioGroup
										style={{
											width: "100%",
										}}
										defaultValue={0}
										name={'sector'}
									>
										<Typography variant="h6">
											{"Select the sector you work in:"}
										</Typography>
										<FormControlLabel control={<Radio
											onChange={(e) => this.handleChangeSector(e)}
											value={0}
											inputProps={{ 'aria-label': 'controlled' }}
											style={{
												color: "#2462FF"
											}}
										/>} label="Education" />
										<FormControlLabel control={<Radio
											onChange={(e) => this.handleChangeSector(e)}
											value={1}
											inputProps={{ 'aria-label': 'controlled' }}
											style={{
												color: "#2462FF"
											}}
										/>} label="Food & Drink Industry" />
										<FormControlLabel control={<Radio
											onChange={(e) => this.handleChangeSector(e)}
											value={2}
											inputProps={{ 'aria-label': 'controlled' }}
											style={{
												color: "#2462FF"
											}} />} label="Food Service/Hospitality" />
										<FormControlLabel control={<Radio
											onChange={(e) => this.handleChangeSector(e)}
											inputProps={{ 'aria-label': 'controlled' }}
											value={3}
											style={{
												color: "#2462FF"
											}} />} label="Health Services" />
										<FormControlLabel control={<Radio
											onChange={(e) => this.handleChangeSector(e)}
											value={4}
											inputProps={{ 'aria-label': 'controlled' }}
											style={{
												color: "#2462FF"
											}} />} label="Government" />
										<FormControlLabel control={<Radio
											onChange={(e) => this.handleChangeSector(e)}
											value={5}
											inputProps={{ 'aria-label': 'controlled' }}
											style={{
												color: "#2462FF"
											}} />} label="Media" />
										<FormControlLabel control={<Radio
											value={6}
											onChange={(e) => this.handleChangeSector(e)}
											inputProps={{ 'aria-label': 'controlled' }}
											style={{
												color: "#2462FF"
											}} />} label="NGO/Charity" />
										<FormControlLabel control={<Radio
											onChange={(e) => this.handleChangeSector(e)}
											value={7}
											inputProps={{ 'aria-label': 'controlled' }}
											style={{
												color: "#2462FF"
											}} />} label="Research" />
										<FormControlLabel control={<Radio onChange={(e) => this.handleChangeSector(e)}
											value={8}
											inputProps={{ 'aria-label': 'controlled' }}
											style={{
												color: "#2462FF"
											}} />} label="Other" />
									</RadioGroup>
									{/* add Checkbox here  */}
									<FormGroup>
										<FormControlLabel
											style={{
												paddingTop: "2rem",
											}}
											control={<Checkbox
												onChange={(e) => this.handleChangeCheckboxCookie(e)}
												// value={0}
												required
												inputProps={{ 'aria-label': 'controlled' }}
												style={{
													color: "#2462FF",
												}}
											/>} label={`I accept this website's terms and conditions including use of cookies that are required for the website to function`
											} />
										<Button
											style={{
												marginTop: "0rem",
												color: "#2462FF",
												textDecoration: "underline",
												fontWeight: "bold",
											}}
											variant="text"
											color="primary"
											target={'_blank'}
											href={disclaimerPdf}
										>
											{"(click here for more information)"}
										</Button>
											{/* error message  */}
											<Typography 
											style={{
												color: 'red'
											}}
												display={this.state.displayCookieErrorMessage}
											>
												{"You are required to accept the terms and conditions to complete registration."}
											</Typography>

									</FormGroup>
									<Button
										variant="outlined"
										disabled={this.state.signUpProcessing}
										ref={this.registerButtonRef as any}
										disableRipple
										fullWidth
										color="primary"
										style={{
											marginTop: "2rem",
											marginBottom: "2rem",
											padding: "1rem",
											color: "white",
											backgroundColor: "#2462FF",
											borderRadius: "4px",
											cursor: "pointer"
										}}
										type="submit"
										onClick={(e) => this.submitSignUp(e)}
									>
										Sign Up
									</Button>
									{/* <LoadingButton
										loading
										loadingPosition="start"
									>
										Save
									</LoadingButton> */}

								</form>
							</Grid>
						</Grid>
					</Grid>
					{/* section 4 */}
					<Grid style={{
						background: "#fff",
						padding: "8rem 4rem",
						borderTop: "3px solid #000",
						borderBottom: "3px solid #000"
					}}>
						<Grid style={{ display: "flex", justifyContent: "space-between" }}>
							<Grid style={{
								width: "48%",
								textAlign: "center",
								margin: "5rem 0 0 0",
								paddingLeft: "8rem",
							}}>
								<Typography variant="h1" style={{
									fontSize: "3rem",
									textAlign: "left",
									fontWeight: "bold",
									width: "80%",
									margin: "1rem 0",
								}}>
									{"About WSRO"}
								</Typography>
								<p style={{
									fontSize: "1.3rem",
									lineHeight: "2.0rem",
									textAlign: "left",
									width: "100%",
									marginTop: "2rem",
								}}>
									{"The World Sugar Research Organisation (WSRO) is an international not for profit Organisation that focuses on the science of sugar(s) to support and contribute to its global understanding in the context of health and diet. WSRO is a globally recognised and trusted resource and knowledge hub on the science of sugar, providing evidence based and relevant scientific information, analysis and perspective."}
									<Button
										style={{
											marginTop: "0rem",
											color: "#2462FF",
											textDecoration: "underline",
											fontWeight: "bold",
										}}
										variant="text"
										color="primary"
										href="https://wsro.org/"
									>
										{"Find Out More"}
									</Button>
								</p>
							</Grid>
							<Grid style={{ width: "48%" }}>
								<img src={Frame3} alt="frame 2" style={{
									width: "70%",
									margin: "0 ",
									display: "block"
								}} />
							</Grid>
						</Grid>
					</Grid>
					{/* footer  */}
					<Grid style={{
						background: "linear-gradient(260.37deg, #FCEFF9 13.88%, #DBE6F3 52.01%, #C4D0F5 90.13%)",
						transform: "rotate(-180deg)",
						padding: "3rem",
						color: "#fff",
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}>
						<p
							style={{
								transform: "rotate(-180deg)",
								fontSize: "1.3rem",
								lineHeight: "2.0rem",
								color: '#191B1E',
								textAlign: "center",
								width: "70%",
								margin: "0 auto",
								marginTop: "2rem",
							}}
						>
							<Grid style={{ textAlign: "center" }}>
								<img src={CREMEGLOBAL} alt="logo" style={{ width: "200px" }} />
							</Grid>

							{"The Global Sugars Intake Dashboard is powered by Creme Global, the independent trusted partner in food science and visualisation. Creme Global advances global consumer health, safety and nutrition through its world class scientific modelling, data science, AI and predictive capabilities."}
						</p>
					</Grid>
					{
						<Snackbar open={this.state.isBarOpen} onClose={this.handleBarClosed}>
							<Alert severity={this.state.severity} sx={{ width: '100%' }}>
								<strong>{this.state.message}</strong>
							</Alert>
						</Snackbar>

					}
				</Paper >
			</Grid >
		);

	}
}
